import clsx from 'clsx';

const DEFAULT_VARIANT_STYLE = "regular";
const DEFAULT_SIZE = "medium";
const basename = "vp-loader";
const VpLoaderConnect = (props, normalizeProps) => {
  const { id, variantStyle, size } = props;
  return {
    /* DOM props */
    getRootProps() {
      return normalizeProps({
        id,
        class: clsx(
          basename,
          variantStyle && variantStyle !== DEFAULT_VARIANT_STYLE && `${basename}--${variantStyle}`,
          size && size !== DEFAULT_SIZE && `${basename}--${size}`
        ),
        "aria-label": "Loading",
        "data-part": "root"
      });
    }
  };
};

export { VpLoaderConnect };
